import { PresentationMode } from '../../common/enums';
import { AppConfig } from '../../models/config/app-config';

export enum VisumAntragsartEnum {
  KURZFRISTIGER_AUFENTHALT="KURZFRISTIGER_AUFENTHALT",
  LANGFRISTIGER_AUFENTHALT="LANGFRISTIGER_AUFENTHALT"
}

export const mekDVisumConfig: AppConfig = {
  umgebung : 'MEK',
  visumAntragsartEnum: 'LANGFRISTIGER_AUFENTHALT',

  // Diese Property wird durch einen vom Backend abgefragten Wert überschrieben
  // (siehe cfg-mek-kurzfristiger-aufenthalt.component.ts und ap2mode.service.ts).
  // Im Backend wird der Ap2Mode durch die Datei active_visum_langfristiger_aufenthalt.cfg in %KARAF_HOME%\etc bzw.
  // %LOCALAPPDATA%\MEK\etc bestimmt (siehe VisumLangfristigerAufenthaltNonVaadinApplicationContentProvider).
  presentationMode: PresentationMode.DEFAULT,

  defaults: {
    lebensunterhaltAufenthaltsdetails: {
      abweichenderVerpflichtungsgeber: {
        art: '1'
      },
      erklaerung: {
        vorbestraftJaNein: 'nein',
        ausgewiesenJaNein: 'nein',
        krankJaNein: 'nein'
      },
      lebensunterhalt: {
        abweichenderVerpflichtungsgeber: 'nein'
      }
    },
    reisedaten: {
      befoerderungsmittel: 'FLUGZEUG'
    },
    referenz: {
      art: '3' // die Validatoren dort werden nicht sofort gesetzt
    }
  },

  isDokumenteActive: true,
  isLichtbildActive: true,
  isFingerabdruckActive: true,
  isReisedatenActive: true,
  isLebensunterhaltAufenthaltsdetailsActive: true,
  isHasKinderActive : true,
  isZusaetzlicheAngabenActive: true
};
